import http from "../../http-common-super-admin";

class DbDataService {
    DeviceList(data) {
      return http.get("/devices/list", { params: data });
    }
    FetchUserDetail(serialNumber, dbName) {
      return http.get("/devices/user/detail?serialNumber="+serialNumber+"&dbName="+dbName);
    }
    SyncDevices(data) {
      return http.get("/devices/sync", { params: data });
    }
    applicationOveruseAlertList(data) {
      return http.get("/application/overuse-alerts", { params: data });
    }
    updateBlockUrls(data) {
      return http.post("/application/update-block-urls", data);
    }
    getBlockUrls() {
      return http.get("/application/block-urls");
    }
    deviceAllocationList(data) {
      return http.get("/devices/allocation/list", { params: data });
    }
    deleteProfile(data) {
      return http.post("/devices/delete/profile", data);
    }
    deleteDevice(data) {
      return http.post("/devices/delete", data);
    }
}

export default new DbDataService();